import React from 'react';

import {
  Actions,
  Action,
  ContentCopyIcon,
  AddLinkIcon,
  FileCopyIcon,
  EditIcon,
} from '@gogame/components';
import Permissions from '@gogame/permissions';

import {
  ACTION_EDIT,
  ACTION_DUPLICATE,
  ACTION_ARCHIVE,
  ACTION_ACTIVATE,
  ACTION_GENERATE_LINKS,
  ACTION_COPY_CAMPAIGN_URL,
  ACTION_MOVE_TO_ANOTHER_AFFILIATE,
} from 'scenes/Campaigns/constants';

export const CampaignActions = ({
  limit = 0,
  actions,
  onEdit,
  onDuplicate,
  onArchive,
  onActivate,
  onGenerateLinks,
  onMoveToAnotherAffiliate,
  onCopy,
}) => {
  return (
    <Permissions actions={actions}>
      {({ isActionAllowed }) => (
        <Actions limit={limit}>
          <Action
            id={ACTION_COPY_CAMPAIGN_URL}
            icon={<ContentCopyIcon />}
            label={'Copy campaign URL'}
            onClick={onCopy}
          />
          <Action
            id={ACTION_GENERATE_LINKS}
            icon={<AddLinkIcon />}
            label={'Generate links'}
            onClick={onGenerateLinks}
            disabled={!isActionAllowed(ACTION_GENERATE_LINKS)}
          />
          <Action
            id={ACTION_MOVE_TO_ANOTHER_AFFILIATE}
            label={'Move to another affiliate'}
            onClick={onMoveToAnotherAffiliate}
            disabled={!isActionAllowed(ACTION_MOVE_TO_ANOTHER_AFFILIATE)}
          />
          <Action
            id={ACTION_DUPLICATE}
            icon={<FileCopyIcon />}
            label={'Duplicate'}
            onClick={onDuplicate}
          />
          <Action
            id={ACTION_EDIT}
            icon={<EditIcon />}
            label={'Edit'}
            onClick={onEdit}
            disabled={!isActionAllowed(ACTION_EDIT)}
          />
          {isActionAllowed(ACTION_ARCHIVE) ? (
            <Action id={ACTION_ARCHIVE} label={'Archive'} onClick={onArchive} />
          ) : null}
          {isActionAllowed(ACTION_ACTIVATE) ? (
            <Action
              id={ACTION_ACTIVATE}
              label={'Activate'}
              onClick={onActivate}
            />
          ) : null}
        </Actions>
      )}
    </Permissions>
  );
};
